import React from 'react';
import styled from 'styled-components';
import { Recommendation } from '@/areas/culture-hub/types/api';
import MobileRecommendationCard from './MobileRecommendationCard';
import { ActionPlanTaskKey } from '@/areas/culture-hub/slices/cultureHubInterventionsSlice';

interface MobileRecommendationTabContentProps {
  recommendations: Recommendation[];
  pillarName: string;
  onAdd: (recommendation: Recommendation) => void;
  selectedActionPlanTaskKeys: ActionPlanTaskKey[];
}

const MobileRecommendationTabContent: React.FC<MobileRecommendationTabContentProps> = ({
  recommendations,
  pillarName,
  onAdd,
  selectedActionPlanTaskKeys,
}) => {
  if (!recommendations || recommendations.length === 0) {
    return <EmptyState>No focus areas were selected for {pillarName}.</EmptyState>;
  }

  return (
    <List>
      {recommendations.map((recommendation) => (
        <MobileRecommendationCard
          key={`${recommendation.recommendation_template_id ?? 'unknown'}_${recommendation.task_index ?? 0}`}
          recommendation={recommendation}
          selectedActionPlanTaskKeys={selectedActionPlanTaskKeys}
          onAdd={onAdd}
        />
      ))}
    </List>
  );
};

export default MobileRecommendationTabContent;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
  min-width: 0;
`;

const EmptyState = styled.div`
  padding: 20px;
  border-radius: 16px;
  background: #f8fafc;
  color: #475569;
  font-size: 14px;
  text-align: center;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow-wrap: anywhere;
`;
